export * from './types';
export * from './config.reducer';

import configReducer from './config.reducer';
export default configReducer;
